// extracted by mini-css-extract-plugin
module.exports = {"container":"language_container__Xkjan","globeIcon":"language_globeIcon__eLf9R","label":"language_label__8HZ9z"};